import { render, staticRenderFns } from "./TabConfirm.vue?vue&type=template&id=410b349d&scoped=true&"
import script from "./TabConfirm.vue?vue&type=script&lang=js&"
export * from "./TabConfirm.vue?vue&type=script&lang=js&"
import style0 from "./TabConfirm.vue?vue&type=style&index=0&id=410b349d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410b349d",
  null
  
)

export default component.exports